import * as React from "react";
import {Box,Stack,Typography, Button} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import moment from 'moment';
import {useScreen} from "../event/hooks/useScreen";
import {useJoin} from "../event/hooks/useJoin";
import LogoutIcon from "@mui/icons-material/Logout";
import LoginIcon from "@mui/icons-material/Login";
import {withJoinContext} from "../event/joinContext";
import {useEvents} from "../event/hooks/useEvent";
import {formatHour, formatLongDate} from "../Service";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import parse from "html-react-parser";

const TodayEventsCard = ({event, setEventToSee, setScreenNumberDefault, setTabValue}) => {
    const {updateEvents} = useEvents();
    const {join, joinStatus ,leave} = useJoin({
        isJoin:event.is_member,
        memberCount: event.member_count
    });

    const handleClickJoin = async (isJoin) => {
        if (isJoin) {
            join(event.id).then(() => (updateEvents()));
        } else {
            leave(event.id).then(() => (updateEvents()));
        }
    }

    const {mode} = useDarkMode();
    return (
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            sx={{padding:1.5}}
            spacing={0.5}
        >
            <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="left"
                sx={{minWidth:'65px'}}
            >
                <Typography sx={{color:'#DD809D', fontSize:'16px', fontWeight:'700'}}>
                    {formatHour(event.start_date)}
                </Typography>
                <Typography sx={{color:'#6D7C84', fontSize:'14px', fontWeight:'700'}}>
                    {moment(event.end_date * 1000).diff(moment(event.start_date * 1000),'hours')}
                    {moment(event.end_date * 1000).diff(moment(event.start_date * 1000),'hours') == 0 ?
                     ' Heure' : ' Heures'
                    }
                </Typography>
            </Stack>
            <Stack
                direction="column"
                justifyContent="flex-start"
                alignItems="left"
                sx={{background: mode.settings.color13 ,padding:1,borderRadius:1,minWidth:'287px !important'}}
                spacing={1}
            >
                <Typography variant={'subtitle1'} sx={{color:'#DD809D'}}>
                    {parse(event.title.text)}
                </Typography>
                <Typography variant={'subtitle3'}
                            sx={{color: mode.settings.color14 ,marginTop:'3px !important',marginBottom:'3px !important'}}
                            dangerouslySetInnerHTML={{ __html: event.description }}
                >
                </Typography>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="left"
                    sx={{}}
                >
                    <Button
                        sx={{color: mode.settings.breadcrumbColor1 ,background: mode.settings.cardBackgroundColor ,height:'30px',fontSize:'16px'}}
                        startIcon={<RemoveRedEyeIcon></RemoveRedEyeIcon>}
                        onClick={() => {
                            setTabValue(5); setEventToSee(event); setScreenNumberDefault(2)
                        }}
                        aria-label="Voir le détail de l'évenement"
                    >
                        <Typography variant={'subtitle3'}>Voir le détail</Typography>
                    </Button>
                    {joinStatus && joinStatus.isJoin === true ?
                        <Button
                            sx={{color:mode.settings.breadcrumbColor1,background: mode.settings.cardBackgroundColor,height:'30px',fontSize:'16px'}}
                            startIcon={<LogoutIcon role="img" aria-label={"Quitter"}/>}
                            onClick={() => handleClickJoin(false)}
                            aria-label="Quitter l'évenement"
                        >
                            Quitter
                        </Button>
                        :
                        <Button
                            startIcon={<LoginIcon role="img" aria-label={"Rejoindre"}/>}
                            sx={{color:mode.settings.breadcrumbColor1,background: mode.settings.cardBackgroundColor,height:'30px',fontSize:'16px'}}
                            onClick={() => handleClickJoin(true)}
                            Quitter
                        >
                            <Typography variant={'subtitle3'}>Rejoindre</Typography>

                        </Button>
                    }
                </Stack>
            </Stack>
        </Stack>
    )
}

export default withJoinContext(TodayEventsCard);
